import { render } from "./SheetDetails.vue?vue&type=template&id=452f9c1c&ts=true"
import script from "./SheetDetails.vue?vue&type=script&lang=ts"
export * from "./SheetDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__